/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 生成以GET方法访问的签名URL
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PresignedUrlGetParams {
  constructor(public filePath: string) {}
}

export default async function (
  params: PresignedUrlGetParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oss/presignedUrlGet`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
